export default {
  border: true,
  rounded: '@theme:card.rounded',
  fontSize: '3',
  fontWeight: 'bold',
  cursor: 'pointer',
  fareBodyItem: {
    borderRight: true,
    alignItems: 'center',
    height: '100',
    paddingWidth: '2',
    paddingBottom: '2',
    paddingTop: '3',
    marginBottom: '4',
    borderColor: 'white',
  },
  showBackgroundImage: false,
  fareItemBackgroundImage: {
    rounded: '@theme:card.rounded',
  },
  showDate: true,
  fareItemDate: {
    textTransform: 'uppercase',
    fontSize: '5',
    paddingBottom: '1',
    monthFormat: 'fullMonths',
    yearStyles: {
      fontWeight: 'light',
    },
  },
  fareItemTripDuration: {
    paddingBottom: '1',
  },
  showOriginDestination: false,
  showHorizontalSeparator: true,
  fareItemHorizontalSeparator: {
    borderTop: true,
    borderWidth: '1',
    paddingBottom: '2',
    width: '25',
    borderColor: 'white',
  },
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    textAlign: 'center',
    style: { lineHeight: '1' },
    pricePromoStyles: {
      fontWeight: 'light',
      textTransform: 'uppercase',
      fontSize: '10px',
    },
    currencyStyles: {
      fontSize: '5',
      marginHeight: '2px',
    },
  },
  fareItemLastSeen: {
    dateStyles: {
      fontWeight: 'light',
    },
  },
  showDepartureReturnBeforePrice: true,
  fareItemDepartureReturn: {
    display: 'flex',
    paddingBottom: '2',
  },
  showDepartureInfo: false,
  showReturnInfo: false,
  showTravelClass: false,
  showJourneyType: false,
  fareItemNoPriceAvailable: {
    showIcon: false,
    alignItems: 'center',
    marginTop: 'auto',
    messageStyles: {
      paddingTop: '15px',
      paddingBottom: '15px',
      fontWeight: 'light',
      width: '75',
    },
    showLinkAvailability: true,
    linkAvailabilityStyles: {
      padding: '0',
      fontWeight: 'bold',
      fontSize: '3',
      textColor: 'white',
      textTransform: 'uppercase',
      style: { textDecoration: 'underline' },
    },
  },
};
